import { Button } from '@mui/material';
import { JourneyLoadingScreen, StandardJourneyBrandedScreen } from '~/components/StandardJourney';

type AppBootstrapScreenProps = {
  state: 'loading' | 'error';
  onRetry: () => void;
};

/**
 * Ecrã de arranque da app, mostrado enquanto a credencial de cliente é obtida
 * e quando esse pedido falha.
 *
 * Antes o `RoutesApp` tinha só `{clientCredencial && <Routes/>}`: se o
 * `POST /v2/auth/client-credential` falhasse, a app renderizava **nada** — o
 * utilizador via uma página em branco com a URL correta e sem saída.
 *
 * Usa o `JourneyLoadingScreen` (Figma 1680:5757) para manter o mesmo visual de
 * espera do resto da plataforma; só o texto muda.
 */
export default function AppBootstrapScreen({ state, onRetry }: AppBootstrapScreenProps) {
  const isError = state === 'error';

  return (
    <StandardJourneyBrandedScreen
      appId="app-bootstrap"
      contentLayout="fullscreen"
      progressPercent={0}
      showBack={false}
      showHeaderProgressBar={false}
    >
      <JourneyLoadingScreen
        appId={isError ? 'app-bootstrap-error' : 'app-bootstrap-loading'}
        busy={!isError}
        message={isError ? 'Não conseguimos iniciar sua sessão' : 'Preparando tudo para você'}
        description={
          isError
            ? 'Verifique sua conexão e tente novamente. Se o problema continuar, fale com o nosso atendimento.'
            : undefined
        }
        action={
          isError ? (
            <Button data-app-id="app-bootstrap-retry" onClick={onRetry} size="large" variant="contained">
              Tentar novamente
            </Button>
          ) : null
        }
      />
    </StandardJourneyBrandedScreen>
  );
}
